import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../utils/visitAttribution';
export default function VisitAttributionObserver() {
  const location = useLocation();
  useEffect(() => { window.LVMVisitAttribution?.capture(); }, [location.pathname, location.search]);
  return null;
}
